export default __webpack_public_path__ + "static/img8-ca96f7b943e35a00ba9e53b31c2539db.webp";